var _excluded = ["children", "variant", "icon", "iconPlacement", "hideLabel", "sizeVariant", "fullWidth", "compact", "disabled", "dangerouslySetClassNames"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import styled from "styled-components";
import ButtonBase from "./ButtonBase";
import forwardRef from "../../private/forwardRef";
// WARNING: This component is not self contained!
// It depends on the relative file path below and is therefore NOT portable
import LinkBase from "../Link/LinkBase";
var ButtonWithLinkVariant = styled(LinkBase).withConfig({
  displayName: "Button__ButtonWithLinkVariant",
  componentId: "sc-etylg7-0"
})(["display:inline-flex;align-items:center;cursor:pointer;"]);
var LabelWithMargin = styled.span.withConfig({
  displayName: "Button__LabelWithMargin",
  componentId: "sc-etylg7-1"
})(["", ";"], _ref => {
  var {
    $iconPlacement,
    theme,
    $sizeVariant
  } = _ref;
  return "margin-" + $iconPlacement + ": " + ($sizeVariant === "small" ? theme.spacing.twoExtraSmall : theme.spacing.extraSmall);
});
var IconWrapper = styled.span.withConfig({
  displayName: "Button__IconWrapper",
  componentId: "sc-etylg7-2"
})(["display:inline-flex;vertical-align:text-top;"]);
/**
 * Buttons are used for actions. There are several button styles each serving a unique type of action.
 *
 * @see [Button documentation](https://construct-kit.reainternal.net/components/web/core/button)
 */
var Button = forwardRef((_ref2, ref) => {
  var {
      children,
      variant = "primary",
      icon,
      iconPlacement = "left",
      hideLabel = false,
      sizeVariant = "large",
      fullWidth = false,
      compact = false,
      disabled = false,
      dangerouslySetClassNames
    } = _ref2,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded);
  var linkVariantMatches = variant.match(/link-(.*)/);
  var renderLabel = () => {
    if (icon) {
      return /*#__PURE__*/React.createElement(LabelWithMargin, {
        $iconPlacement: iconPlacement,
        $sizeVariant: sizeVariant,
        className: dangerouslySetClassNames == null ? void 0 : dangerouslySetClassNames.label
      }, children);
    }
    return children;
  };
  var renderIcon = () => {
    if (icon) {
      return linkVariantMatches ? /*#__PURE__*/React.createElement(IconWrapper, {
        className: dangerouslySetClassNames == null ? void 0 : dangerouslySetClassNames.iconWrapper
      }, icon) : icon;
    }
  };
  var commonProps = _extends({
    $sizeVariant: sizeVariant,
    $fullWidth: fullWidth,
    $compact: compact,
    disabled: disabled,
    "aria-label": hideLabel && typeof children === "string" ? children : undefined,
    ref
  }, props);
  var renderIconAndLabel = () => /*#__PURE__*/React.createElement(React.Fragment, null, iconPlacement === "left" && renderIcon(), !hideLabel ? renderLabel() : null, iconPlacement === "right" && renderIcon());
  return linkVariantMatches ? /*#__PURE__*/React.createElement(ButtonWithLinkVariant, _extends({
    as: "button",
    $variant: linkVariantMatches[1]
  }, commonProps), renderIconAndLabel()) : /*#__PURE__*/React.createElement(ButtonBase, _extends({
    $variant: variant
  }, commonProps), renderIconAndLabel());
});
Button.displayName = "Button";
export default Button;
export { ButtonBase };